<div class="coupon-form">
  <div class="coupon-form__header">
    <a *ngIf="!couponExist" (click)="showDiscountInput = true" class="coupon-form__link" 
    translate>payment-info.coupon-form.link</a>
  </div>
  <div *ngIf="showDiscountInput" class="coupon-form__form">
    <span translate>payment-info.coupon-form.disclaimer</span>
    <form [formGroup]="form" (ngSubmit)="checkDiscount()" class="coupon-form__promocode">
      <div class="vox-input-group vox-input-group_dense" [ngClass]="{ 'vox-input-group_invalid': error }">
          <input class="vox-text-field" formControlName="code" [placeholder]="'payment-info.coupon-form.placeholder' | translate"/>
          <i *ngIf="form.value.code && !error" (click)="clearInput()" class="icon-small-close"></i>
          <i class="vox-text-field__icon icon-small-alert"></i>
          <span *ngIf="errorExpired" class="vox-input-group__error-message" translate>payment-info.coupon-form.errors.expired</span>
          <span *ngIf="!errorExpired" class="vox-input-group__error-message" translate>payment-info.coupon-form.errors.invalid</span>
      </div>
      <button [disabled]="!canCheckDiscount" class="vox-btn vox-btn-secondary" type="submit"
      [ladda]="loading" data-style="zoom-in" data-spinner-color="#fff">
        <span translate>payment-info.coupon-form.button</span>
      </button>
    </form>
  </div>
</div>